import styled from "styled-components";
import { PropListItem } from "../styles";

export const CustomPropListItem = styled(PropListItem)`
  user-select: none;
  position: relative;
  > div {
    width: 100%;
    margin: 0;
    padding: 0;

    > span {
      font-size: 12px;
    }

    > div {
      > div {
        > span {
          margin-left: 10px;
        }
      }
    }
    .payment-button-list-select {
      div {
        padding: 0;
      }
    }
  }

  label {
    user-select: none;
  }
`;

export const EditPaymentButton = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  top: 9px;
  right: 0;
  padding: 3px;
`;

export const NewPaymentButton = styled.div`
  width: 100%;
  height: 100%;
  color: #44adf8;
  font-size: 12px;
  padding: 8px;

  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Option = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 3px;
`;

export const ConfigurePayAccountWrapper = styled.div`
  width: 100%;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  
  font-size: 12px;
  line-height: 1.5;
  color: #212121;
  
  a, button {
    min-width: 200px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;

    font-weight: 500;
    color: #50AFF4;
    text-decoration: none;
  }

  button {
    border: 0;
    background-color: transparent;
  }
`